<template>
    <div>
        <!-- informacion de quiniela -->
        <div class="card">
            <div class="card-body">
                <h3>Reporte de códigos quiniela {{ quiniela.nombre }}</h3>
                <p>
                    {{ quiniela.torneo.nombre }}<br />{{ quiniela.tipo.nombre }}
                </p>
            </div>
        </div>

        <!-- reporte-->
        <div class="card">
            <table class="table table-sm table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">#</th>
                        <th>Código</th>
                        <th>Comentarios</th>
                        <th class="text-center">Disponible</th>
                        <th>Fecha envío</th>
                        <th>Fecha de ingreso</th>
                        <th>Usuario</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(codigo, i) of codigos" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td>{{ codigo.codigo }}</td>
                        <td>{{ codigo.comentario }}</td>
                        <td class="text-center">
                            <span v-if="codigo.usado" class="badge bg-danger"
                                >No</span
                            >
                            <span v-else class="badge bg-success">Si</span>
                        </td>
                        <td>
                            {{ codigo.enviado }}
                        </td>
                        <td>
                            {{ codigo.usado }}
                        </td>
                        <td>
                            {{ codigo.usuario }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: ["quiniela", "codigos"],
};
</script>
